import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * LoadingSpinner - Centered loading spinner with optional message
 */
const LoadingSpinner = ({
  message = 'Loading...',
  size = 32,
  className = ''
}) => {
  return (
    <div className={`flex flex-col items-center justify-center py-8 ${className}`}>
      <Loader2 size={size} className="animate-spin text-purple-500 mb-3" />
      {message && (
        <p className="text-gray-400 text-sm">{message}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
